import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {NzMenuModule} from 'ng-zorro-antd/menu';
import {CommonModule} from '@angular/common';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzToolTipModule} from 'ng-zorro-antd/tooltip';
import {NavigationEnd, Router, RouterModule} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from "@ngx-translate/core";
import {jwtDecode} from 'jwt-decode';
import {filter, Subscription} from 'rxjs';
import {AppMode, DEFAULT_APP_MODE} from '../models/app-mode.model';
import {AppModeService} from '../services/app-mode.service';
import {AuthService} from '../services/auth.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
    imports: [
        CommonModule,
        NzMenuModule,
        NzIconModule,
        RouterModule,
        NzButtonModule,
        NzToolTipModule,
        FormsModule,
        TranslateModule
    ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.less'
})
export class SidebarComponent implements OnInit, OnDestroy{
  @Input() theme: boolean = true; // Input from parent component for theme
  @Input() isCollapsed = false;
  @Output() isCollapsedChange = new EventEmitter<boolean>();
  userRole: string = '';
  appMode: AppMode = DEFAULT_APP_MODE;
  isQrPosterTemplateActive = false;

  private appModeSubscription?: Subscription;
  private routerSubscription?: Subscription;

  constructor(
    private appModeService: AppModeService,
    private authService: AuthService,
    private router: Router,
  ) {}

  ngOnInit() {
    const token = localStorage.getItem('authToken');
    if (token) {
      const decodedToken: any = jwtDecode(token);
      this.userRole = decodedToken.role;
    }

    this.appMode = this.appModeService.getAppMode();
    this.appModeSubscription = this.appModeService
      .getAppModeChanges()
      .subscribe(mode => {
        this.appMode = mode;
      });

    this.updateQrPosterTemplateActiveState();
    this.routerSubscription = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => this.updateQrPosterTemplateActiveState());
  }

  ngOnDestroy(): void {
    this.appModeSubscription?.unsubscribe();
    this.routerSubscription?.unsubscribe();
  }

  // Request a collapsed-state change from the application shell.
  toggleCollapsed(): void {
    this.isCollapsedChange.emit(!this.isCollapsed);
  }

  get isLoggingOut(): boolean {
    return this.authService.isLoggingOut;
  }

  get isEmergencyMode(): boolean {
    return this.appModeService.isEmergencyMode(this.appMode);
  }

  get isHospitalityMode(): boolean {
    return this.appModeService.isHospitalityMode(this.appMode);
  }

  hasPermission(permission: string): boolean {
    return this.authService.hasPermission(permission);
  }

  hasAnyPermissions(permissions: string[]): boolean {
    return this.authService.hasAnyPermissions(permissions);
  }

  private updateQrPosterTemplateActiveState(): void {
    this.isQrPosterTemplateActive = this.router.isActive(
      this.router.createUrlTree(['/qr-poster-template']),
      {
        paths: 'exact',
        queryParams: 'ignored',
        matrixParams: 'ignored',
        fragment: 'ignored',
      },
    );
  }
}
